// @flow
/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import styles from "./styles.css"

import { Cell, ResponsiveContainer, PieChart, Pie, LabelList, Tooltip } from "recharts"

import Spacer from "../../Spacer"
import Card from "../../Card"

const COLOR_PALETTE = [
  "#0288D1",
  "#039BE5",

  "#29B6F6",
  "#03A9F4",

  "#81D4FA",
  "#4FC3F7",

  "#B3E5FC",
]


export default class DebtPhaseEventsPie extends Component {
  props: {
    name: string,
    data: mixed[],
  }

  renderChart ( data ) {
    /* https://github.com/recharts/recharts/issues/172 */
    return (
      <ResponsiveContainer width="99%" height="99%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            innerRadius="60%"
            outerRadius="90%"
          >
            {
              data.map( ( entry, index ) => (
                <Cell
                  key={index}
                  fill={COLOR_PALETTE[ index % COLOR_PALETTE.length ]}
                />
              ) )
            }
            <LabelList dataKey="value" fill="#FFF"/>
          </Pie>
          <Tooltip/>
        </PieChart>
      </ResponsiveContainer>
    )
  }

  renderNoData () {
    return (
      <div className={styles.noData}>
        Sem Dados
      </div>
    )
  }

  render () {
    const data = this.props.data || [] // Should we do this? or display "No data"
    const hasData = data.length > 0
    return (
      <div className={styles.root}>
        <Card style={{ flex: "1" }}>
          <div className={styles.title}>
            {this.props.name}
          </div>
          <div className={styles.chartWrapper}>
            { hasData ? this.renderChart( data ) : this.renderNoData() }
          </div>
        </Card>
        <Spacer size={1}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Charts/DebtPhaseEventPie/index.jsx